    /**
    * Gets the programmatic name of the entire locale, with the language,
    *   country and variant separated by underbars. The Language is always lower case,
    *   and country is always upper case. If the language is missing,
    *   the string will begin with an underscore character.
    *   If both the language and country fields are missing,
    *   this function will return the empty string,
    *   even if the variant field is filled in (you cannot have a locale with just a variant--
    *   the variant must accompany a valid language or country code). Examples: "en"
    *
    */
export const sidebar = {
    en: {
        sidebar:'sidebar',
        product_type:'Product Type',
        led_load_detail:'LED Load Management',
        product_onboarding:'Product Onboarding',
        pole_management:'Pole Management',
        lamp_management:'Lamp Management',
        project_onboarding:'Project Onboarding',
        dashboard:'Dashboard',
        customer_management:'Customer Management',
        site_management:'Site Management',
        property_management:'Hierarchy Management',
        user_onboarding:'User Onboarding',
        device_inventory:'Device Inventory',
        device_onboarding: 'Device Onboarding',
        device_allocation:"Device Allocation",
        feeder_onboarding: 'Feeder Onboarding',
        devices:'Devices',
        feeders: 'Feeders',
        feeder_allocation:"Feeder Allocation",
        device_assigning:"Device Assign",
        consumption_management:'Consumption Management',
        gis_view:'GIS View',
        reports:'Reports',
        roles_and_persmissions:'Roles and Permissions',
        email_and_sms:'Email and SMS',
        email_template:'Email Template',
        sms_template:'SMS template',
        address_management:'Address Management',
        property_type:'Property Type',
        battery_health:'Battery Health',
        settings:'Settings',
        location_management:'Location Management',
        location:'location',
        zone_management:'Zone Management',
        consumption_view:'Consumption View',
        drs_file:'DRS File',
        consumer_consumption:'Consumer Consumption',
        drs_level_consumption:'DRS Level Consumption',
        tampering:'Tampering',
        meter_health:'Meter Health',
        log_management:'Log Management',
        feeder_management: 'Feeder Management',
        hierarchy:'Hierarchy',
        add_hierarchy:'Add Hierarchy',
        city_management:'City Management',
        state_management:'State Management',
        pincode_management:'Pincode Management',
        property_type_management:'Property Type',
        property_sub_type_management:'Property Subtype',
        alert:'Alert',
        application:'Application',
        device_offline_config:'Device Offline Config',
        customer_onboarding:'Customer Onboarding',
        masterdata_management:"Masterdata Management",
        device_installation_report:"Device Installation Report",
        firmware_management:"Firmware Management",
        firmware_updates_report: "Firmware Update Report"
    },

    ar: {
        sidebar:'الشريط الجانبي',
        product_type:'نوع المنتج',
        led_load_detail:'إدارة تحميل LED',
        product_onboarding:'إعداد المنتج',
        pole_management:'إدارة العمود',
        lamp_management:'إدارة المصباح',
        project_onboarding:'إعداد المشروع',
        dashboard:'لوحة القيادة',
        customer_management:'ادارة الزبائن',
        site_management:'إدارة الموقع',
        property_management:'إدارة التسلسل الهرمي',
        user_onboarding:'إعداد المستخدم',
        device_inventory:'جرد الجهاز',
        device_onboarding: 'إعداد الجهاز',
        device_allocation:"تخصيص الجهاز",
        feeder_onboarding: 'على متن الطائرة',
        devices:'الأجهزة',
        feeders: 'المغذيات',
        feeder_allocation:"تخصيص المغذي",
        device_assigning:"تعيين الجهاز",
        consumption_management:'إدارة الاستهلاك',
        gis_view:'عرض GIS',
        reports:'التقارير',
        roles_and_persmissions:'الأدوار والتصاريح',
        email_and_sms:'البريد الإلكتروني والرسائل القصيرة',
        email_template:'نموذج البريد الإلكتروني',
        sms_template:'قالب SMS',
        address_management:'إدارة العناوين',
        property_type:'نوع الملكية',
        battery_health:'صحة البطارية',
        settings:'الاعدادات',
        location_management:'إدارة الموقع',
        location:'الموقع',
        zone_management:'إدارة المنطقة',
        consumption_view:'عرض الاستهلاك',
        drs_file:'ملف DRS',
        consumer_consumption:'استهلاك المستهلك',
        drs_level_consumption:'استهلاك مستوى DRS',
        tampering:'العبث',
        meter_health:'صحة العدادات',
        log_management:'إدارة السجل',
        feeder_management: 'إدارة المغذي',
        hierarchy:'التسلسل الهرمي',
        add_hierarchy:'أضف التسلسل الهرمي',
        city_management:'إدارة المدينة',
        state_management:'إدارة الدولة',
        pincode_management:'إدارة الرمز السري',
        property_type_management:'نوع الملكية',
        property_sub_type_management:'نوع الملكية الفرعي',
        alert:'تحذير',
        application:'طلب',
        device_offline_config:'تكوين الجهاز دون اتصال',
        customer_onboarding:'إعداد العملاء',
        masterdata_management:"إدارة البيانات الرئيسية",
        device_installation_report:"تقرير تثبيت الجهاز",
        firmware_management: "إدارة البرنامج الثابت",
        firmware_updates_report: "تقرير تحديث البرنامج الثابت"
    }
}
